import React, { useState, useEffect } from "react";
import { Col } from "reactstrap";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";

const AuthSlider = () => {
    const domain = window.location.hostname;
    const [logoUrl, setLogoUrl] = useState(() => {
        try {
            const cachedData = localStorage.getItem(`custom_images_${domain}`);
            const cachedImages = cachedData ? JSON.parse(cachedData) : {};
            return cachedImages.logoWhite || cachedImages.logo || null;
        } catch {
            return null;
        }
    });
    const [logoWidth, setLogoWidth] = useState(90);

    const updateLogo = () => {
        try {
            const cachedData = localStorage.getItem(`custom_images_${domain}`);
            const cachedImages = cachedData ? JSON.parse(cachedData) : {};
            const newLogo = cachedImages.logoWhite || cachedImages.logo || null;
            setLogoUrl(newLogo);
            setLogoWidth(cachedImages.logoLoginWidth || 90);
        } catch (error) {
            console.error('Erro ao carregar imagem do cache:', error);
            setLogoUrl(null);
        }
    };

    useEffect(() => {
        // Atualiza logo inicialmente
        updateLogo();

        // Listener para atualizar quando o localStorage mudar
        const interval = setInterval(() => {
            updateLogo();
        }, 500);

        // Cleanup após 5 segundos (tempo suficiente para API responder)
        const timeout = setTimeout(() => {
            clearInterval(interval);
        }, 5000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    return (
        <React.Fragment>

            <Col lg={6}>
                <div className="p-lg-5 p-4 auth-one-bg h-100">
                    <div className="bg-overlay"></div>
                    <div className="position-relative h-100 d-flex flex-column">
                        {logoUrl && (
                            <div className="mb-4">
                                <Link to="/dashboard" className="d-block">
                                    <img src={logoUrl} alt="Logo" height={logoWidth} />
                                </Link>
                            </div>
                        )}

                        <div className="mt-auto">

                            <Carousel
                                showThumbs={false}
                                autoPlay={true}
                                showArrows={false}
                                showStatus={false}
                                infiniteLoop={true}
                                className="carousel slide"
                                id="quotescarouselIndicators"
                            >
                                <div className="carousel-inner text-center text-white pb-5">
                                    <div className="item">
                                        <p className="fs-15 fst-italic">
                                            Gestão de plantões sem complicação!
                                        </p>
                                    </div>
                                </div>
                                <div className="carousel-inner text-center text-white  pb-5">
                                    <div className="item">
                                        <p className="fs-15 fst-italic">
                                            O jeito mais fácil e rápido de organizar escalas médicas!
                                        </p>
                                    </div>
                                </div>
                                <div className="carousel-inner text-center text-white  pb-5">
                                    <div className="item">
                                        <p className="fs-15 fst-italic">
                                            Agilidade, eficiência e controle total dos seus plantões!
                                        </p>
                                    </div>
                                </div>
                                <div className="carousel-inner text-center text-white  pb-5">
                                    <div className="item">
                                        <p className="fs-15 fst-italic">
                                            Menos burocracia, mais tempo para o que importa!
                                        </p>
                                    </div>
                                </div>
                                <div className="carousel-inner text-center text-white  pb-5">
                                    <div className="item">
                                        <p className="fs-15 fst-italic">
                                           Sua escala organizada em poucos cliques!
                                        </p>
                                    </div>
                                </div>
                            </Carousel>

                        </div>
                    </div>
                </div>
            </Col>
        </React.Fragment>
    );
};

export default AuthSlider;